import { WOW_BADGE_SRC } from '@/constants/Srp'
import Image from 'next/image'
import { FC } from 'react'

const WowBadge: FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`flex flex-middle ${className}`} style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
    <Image unoptimized alt='WOW' height={13} src={WOW_BADGE_SRC} width={40} />
  </span>
)

export default WowBadge